export default __webpack_public_path__ + "images/aabecedcba376ce32f404999aadea93e-poverty_small.webp";